module.exports = __webpack_public_path__ + "static/product_shot_travesia-f78a861fef6f876b2f25888ad62d72ca.jpg";